module.exports = __webpack_public_path__ + "img/home_top6.eecb8cf8.png";